import { type TracksStore, TrackType } from '@/shared/store/tracks.store.tsx'
import type {
  AudioFormAssets,
  AudioFormLayer,
} from '../../../../audio-form/data/dto/audio-form-input.ts'
import { trackVolumeToGain } from './track-volume-to-gain.ts'

export const mapSoundEffectsToAudioformLayers = (
  trackStore: TracksStore,
  assets: AudioFormAssets
): AudioFormLayer[] => {
  const tracks = trackStore.tracks.filter(
    (track) => track.type === TrackType.SoundEffects
  )

  return tracks.map((track) => {
    const gain = trackVolumeToGain(track.volume)
    const sortedClips = track.clips
      .filter(
        (clip): clip is typeof clip & { startAt: number } =>
          clip.startAt !== undefined
      )
      .sort((a, b) => a.startAt + a.startOffset - (b.startAt + b.startOffset))

    let previousEnding = 0

    const clips = sortedClips.flatMap(
      ({
        mediaId,
        startAt,
        startOffset,
        duration,
        endOffset,
        fadeIn,
        fadeOut,
      }) => {
        const assetRef = Object.entries(assets).find(
          ([, asset]) =>
            asset.type === 'soundEffect' && asset.soundEffectAlias === mediaId
        )?.[0]

        if (!assetRef) return []

        const marginStart = startAt + startOffset - previousEnding
        previousEnding = startAt + duration + endOffset

        return [
          {
            assetRef,
            ...(fadeIn > 0 && { fadeIn }),
            ...(fadeOut > 0 && { fadeOut }),
            ...(startOffset > 0 && { readPosition: startOffset }),
            forcedDuration: duration - startOffset + endOffset,
            marginStart: Math.max(marginStart, 0),
            gain,
          },
        ]
      }
    )

    return { clips }
  })
}
